import { getQueryParameters } from "utils/utils"

export const translateText = (translationMap, key, returnHTML = true) => {
  const { language, debug } = getQueryParameters()
  if (!language || !translationMap) return key
  if (!key) return key
  if (typeof key === "string" || key instanceof String) {
    if (!translationMap[language]) {
      if (!debug) return key
      return `Missing Language ${language}`
    } else {
      if (translationMap[language][key]) {
        return translationMap[language][key]
      } else {
        if (!debug) return key
        return returnHTML ? (
          <div style={{ color: "red" }}>Missing Translation: {key}</div>
        ) : (
          `>>>>Missing Translation: ${key}`
        )
      }
    }
  } else {
    if (!debug) return key
    return returnHTML ? (
      <div style={{ color: "red" }}>We only translate strings {returnHTML}</div>
    ) : (
      `>>>>We only translate strings`
    )
  }
}

export const getQuestionTextForLanguage = (question, key) => question[key]

export const goToLanguageSite = newLanguage => {
  const query = getQueryParameters()
  query.language = newLanguage.id
  window.location.href =
    window.location.origin +
    window.location.pathname +
    "?" +
    Object.keys(query)
      .map(param => `${param}=${query[param]}`)
      .join("&")
}

export const translateDBArray = (
  translatedMap,
  array,
  overrideKey = "value"
) => {
  const result = array.map(x => ({
    ...x,
    [overrideKey]: translateText(translatedMap, x[overrideKey]),
  }))
  return result
}
